import React from 'react';
import { GuestWeddingResponse } from '../../gds-api-client';
import RightRail from '../../gs-component-right-rail';
import { GuestWedding } from '../GuestWeddingTypes';
import RSVPSettings from './RsvpSettings';
import EditInPreviewRSVPSettings from './EditInPreviewRsvpSettings';
import { EventType } from '../EventTypes';
import { Household } from '../HouseholdTypes';

export interface RSVPSettingsRailProps {
  showRail: boolean;
  rsvpOnInEvents: boolean;
  hasPrivateEvent: boolean;
  wwsState: string;
  guestWedding?: GuestWedding;
  onClickEditForm: () => void;
  onClose: () => void;
  leftButtonOnClick?: () => void;
  onSuccess?: (gdsresponse: GuestWeddingResponse) => void;
  onEscapeKey?: () => void;
  editInPreview?: boolean | false;
  events?: EventType[];
  openEventModal?: (id: string) => void;
  showVisualization?: boolean;
  households?: Household[];
}

const RSVPSettingsRightRail: React.FC<RSVPSettingsRailProps> = props => {
  const { showRail, guestWedding, onEscapeKey, editInPreview } = props;
  if (!guestWedding) {
    return null;
  }

  return (
    <RightRail open={showRail} onEscapeKey={onEscapeKey}>
      {!editInPreview ? <RSVPSettings {...props} /> : <EditInPreviewRSVPSettings {...props} />}
    </RightRail>
  );
};

export default RSVPSettingsRightRail;
